module.exports = "/assets/233f9541998ac9bb619122ece2ea8b70.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/MJ.png
// module id = 1616
// module chunks = 0